import styled from 'styled-components';

const labelManageStyled = styled.div`
  > div {
    display: flex;
    gap: 24px;
    justify-content: space-between;
    /* height: 100%; */
    width: 100%;
    overflow: hidden;
    flex-grow: 1;
  }
  .search-condition-left {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 12px;
    .label-add-btn {
      width: 100%;
      height: 48px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
    }
    .search-condition-left-tree {
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      margin-top: 24px;
      background-color: #fff;
    }
  }
`;
export default labelManageStyled;
